import Loading from "../../components/loading";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import AddButton from "../../components/AddButton";
import { useSelector } from "react-redux/es/exports";
import EditButton from "../../components/EditButton";
import TempDataTable from "../../components/TemDataTable";
import { getAppVersions } from "../../services/appVersionService";

const headerTable = [
  {
    name: "appVersions.platform",
  },
  {
    name: "appVersions.latest_version",
  },
  {
    name: "appVersions.min_version",
  },
  {
    name: "appVersions.force_update",
  },
  {
    name: "appVersions.updated_at",
  },
  <span className="sr-only">Actions</span>,
];

const bodyTable = [
  "platform",
  "latestVersion",
  "minVersion",
  "forceUpdate",
  "updatedAt",
  "actions",
];

function AppVersionList({ t }) {
  const navigate = useNavigate();
  const [appVersions, setAppVersions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useSelector((state) => state.user);

  const fetchAppVersions = async () => {
    setIsLoading(true);
    try {
      const response = await getAppVersions(token);

      if (response?.success) {
        const data = response?.data.map((item) => {
          return {
            platform: item.platform,
            latestVersion: item.latestVersion || "—",
            minVersion: item.minVersion || "—",
            forceUpdate: (
              <div className="flex items-center h-5">
                <input
                  disabled
                  type="checkbox"
                  checked={!!item.forceUpdate}
                  className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300 ml-5"
                />
              </div>
            ),
            updatedAt: item.updatedAt
              ? new Date(item.updatedAt).toLocaleString()
              : "—",
            actions: (
              <div className="flex justify-end">
                <EditButton
                  onclick={() => {
                    navigate(`/app-versions/update/${item.platform}`);
                  }}
                />
              </div>
            ),
          };
        });
        setAppVersions(data);
      } else {
        navigate("/error", {
          state: {
            status: response?.status,
            message: response?.message ? response.message : null,
          },
        });
      }
    } catch (error) {
      console.error("Fetch app versions error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAppVersions();
  }, []);

  const sortFunction = (value) => {
    console.log("sortFunction", value);
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="px-4 py-4 sm:px-6 lg:px-8">
          <div className="mb-2 sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold text-gray-900">
                {t("sidebar_app_versions")}
              </h1>
            </div>
            <AddButton title={t("appVersions.add")} url={"add"} />
          </div>
          <div>
            <TempDataTable
              data={appVersions}
              headerTable={headerTable}
              bodyContent={bodyTable}
              sortFunction={sortFunction}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default withTranslation()(AppVersionList);
